(function () {
  'use strict';

  /* ─── helpers ─── */
  function parseImages(raw) {
    try { return JSON.parse(raw); } catch (e) { return []; }
  }

  function readImagesFromPageContent() {
    var el = document.getElementById('lb-page-content');
    if (!el) return [];
    var script = el.querySelector('script[type="application/json"]');
    if (script) return parseImages(script.textContent);
    var imgs = el.querySelectorAll('img');
    if (imgs.length > 0) return Array.from(imgs).map(function (i) { return i.src; }).filter(Boolean);
    return [];
  }

  /* ─── initFlipbook — St.PageFlip edition ─── */
  function initFlipbook(container, images) {
    var bookContainer = container.querySelector('.lb-book-container');
    var book          = container.querySelector('.lb-book');
    var prevBtns      = Array.from(container.querySelectorAll('.lb-prev'));
    var nextBtns      = Array.from(container.querySelectorAll('.lb-next'));
    var counter       = container.querySelector('.lb-counter');
    if (!book || !bookContainer) return;

    /* Build one .page <div> per image inside the existing .lb-book */
    book.innerHTML = '';
    images.forEach(function (src, i) {
      var page = document.createElement('div');
      page.className = 'page';
      var img = document.createElement('img');
      img.src     = src;
      img.alt     = 'Lookbook page ' + (i + 1);
      img.loading = i < 2 ? 'eager' : 'lazy';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;margin:0;padding:0;';
      page.appendChild(img);
      book.appendChild(page);
    });

    function calcDimensions() {
      var availW = bookContainer.getBoundingClientRect().width;
      var pw = Math.round(availW / 2);
      var ph = Math.round(pw * 1.42);
      var maxH = Math.round(window.innerHeight * 0.82);
      if (ph > maxH) { ph = maxH; pw = Math.round(ph / 1.42); }
      return { pw: pw, ph: ph };
    }

    var d = calcDimensions();
    var pageWidth  = d.pw;
    var pageHeight = d.ph;

    book.style.width  = (pageWidth * 2) + 'px';
    book.style.height = pageHeight + 'px';

    var pageFlip = new St.PageFlip(book, {
      width:               pageWidth,
      height:              pageHeight,
      showCover:           true,
      mobileScrollSupport: false,
      useMouseEvents:      false,
      drawShadow:          true,
      flippingTime:        800,
      usePortrait:         false,
      startZIndex:         0,
      autoSize:            true,
      maxShadowOpacity:    0.5,
      clickEventForward:   false
    });

    pageFlip.loadFromHTML(book.querySelectorAll('.page'));

    /* Swipe */
    var touchStartX = null;
    bookContainer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    bookContainer.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) { dx > 0 ? pageFlip.flipNext() : pageFlip.flipPrev(); }
      touchStartX = null;
    }, { passive: true });

    /* Resize — update dimensions only, never destroy PageFlip */
    var resizeTimer;
    var lastContainerWidth = bookContainer.getBoundingClientRect().width;

    function applyResize() {
      var newW = bookContainer.getBoundingClientRect().width;
      if (Math.abs(newW - lastContainerWidth) < 2) return; /* ignore sub-pixel jitter */
      lastContainerWidth = newW;
      var nd = calcDimensions();
      book.style.width  = (nd.pw * 2) + 'px';
      book.style.height = nd.ph + 'px';
      pageFlip.update();
    }

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(applyResize);
        });
      }, 250);
    });

    /* Counter */
    function updateCounter() {
      if (!counter) return;
      var cur   = pageFlip.getCurrentPageIndex();
      var total = pageFlip.getPageCount();
      counter.textContent = (cur + 1) + ' / ' + total;
    }

    /* Button state */
    function updateButtons() {
      var cur   = pageFlip.getCurrentPageIndex();
      var total = pageFlip.getPageCount();
      prevBtns.forEach(function (b) { b.disabled = (cur === 0); });
      nextBtns.forEach(function (b) { b.disabled = (cur + 2 >= total); });
    }

    pageFlip.on('flip', function () { updateCounter(); updateButtons(); });
    pageFlip.on('changeState', function () { updateCounter(); updateButtons(); });

    prevBtns.forEach(function (b) { b.addEventListener('click', function () { pageFlip.flipPrev(); }); });
    nextBtns.forEach(function (b) { b.addEventListener('click', function () { pageFlip.flipNext(); }); });

    document.addEventListener('keydown', function (e) {
      if (!document.contains(container)) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') pageFlip.flipNext();
      if (e.key === 'ArrowLeft'  || e.key === 'ArrowUp')   pageFlip.flipPrev();
    });

    updateCounter();
    updateButtons();
  }

  /* ─── boot ─── */
  function initAll() {
    document.querySelectorAll('[data-lookbook]').forEach(function (container) {
      var images;
      if (container.hasAttribute('data-images-from-page')) {
        images = readImagesFromPageContent();
      } else {
        images = parseImages(container.getAttribute('data-images') || '[]');
      }
      if (images.length === 0) return;
      initFlipbook(container, images);
    });
  }

  function boot() {
    /* Wait one rAF so the browser has painted and containers have real widths */
    requestAnimationFrame(function () {
      requestAnimationFrame(initAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
